<template>
  <div class="cursor-pointer">
    <div class="content grid justify-center 1.2xl:justify-between mr-3"
         :class="{'grid-cols-1 1.2xl:grid-cols-display-2 1.5xl:grid-cols-display-3 1.8xl:grid-cols-display-4 2.7xl:grid-cols-display-6 4k:grid-cols-display-8': filterOpen,'grid-cols-display-3 1.2xl:grid-cols-display-4 1.5xl:grid-cols-display-4 fhd:grid-cols-display-6 2xl:grid-cols-display-6 2.7xl:grid-cols-display-8 4k:grid-cols-display-12': !filterOpen}">
      <c-box v-for="(box, index) in boxes" :key="index" :box="box"
             class="justify-self-center 1.5xl:justify-self-start"/>
    </div>
    <button v-if="hasMore" class="classen__button justify-self-center hover__button col"
            @click="$emit('load-more')">
      {{ getTranslation('loadMoreItems') }}
    </button>
    <div v-if="boxes.length === 0" class="">
      {{ getTranslation('noPackagingsFound') }}
    </div>
  </div>
</template>
<script>
import BoxView from "./BoxView";
import getTranslation from "../../../../mixins/getTranslation";

export default {
  name: "BoxesDisplay",

  mixins: [getTranslation],

  components: {
    'c-box': BoxView,
  },

  props: {
    boxes: {required: true, type: Array},
    filterOpen: {required: true, type: Boolean},
    hasMore: {required: true, type: Boolean},
  },

  data() {
    return {}
  },

  created() {

  },

  destroyed() {

  },

  computed: {},

  watch: {},

  methods: {}
}
</script>
